module.exports = __webpack_public_path__ + "img/collaboration0.7370ac4e.png";